import { styled } from '@mui/material/styles';

export const SelectFileButtonRoot = styled('span')`
  display: inline-flex;
  overflow: hidden;
  position: relative;

  & input {
    position: absolute;
    top: -1000px;
    left: -1000px;
    opacity: 0;
  },
`;
